export const WORDS = [
  "steve"
]
